import { render, staticRenderFns } from "./PromotionLineItemModal.vue?vue&type=template&id=4eab6c40&"
import script from "./PromotionLineItemModal.vue?vue&type=script&lang=ts&"
export * from "./PromotionLineItemModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports